<app-lms-modal-frame [title]="'Employment Confirmation'" [pageHeadWidth]="500">
  <div modal-body class="center-screen">
    <form [formGroup]="confirmedForm" class="mx-2 py-0" ngNativeValidate>
      <table id="employConfirm" class="table table-striped table-sm">
        <caption>
          Loan Details - Employment Confirmation
        </caption>

        <tbody>
          <tr>
            <td>
              <p class="text-center text-wrap">
                <b>I confirm that I have contacted the client's employer,
                  and that the client is employed at the given employer.</b>
              </p>
            </td>
          </tr>

          <tr>
            <td>
              <div class="py-2">
                <div class="center-section">
                  <i class="fas fa-phone fa-2x p-2 text-primary"></i>
                  <label for="empConfirmed">Is employment confirmed?</label><br>
                  <div class="form-check form-switch d-inline-flex mx-3 my-2 py-2">
                    <input
                      id="empConfirmed"
                      class="form-check-input"
                      type="checkbox"
                      formControlName="empConfirmed"
                    >
                  </div>
                </div>
                <p><strong>
                    {{confirmedForm!.value.empConfirmed ? 'Confirmed employment!' : 'Employment NOT confirmed!'}}
                </strong></p>
              </div>
            </td>
          </tr>

          <!-- Additional fields - only shown when empConfirmed is true  -->
          <tr *ngIf="confirmedForm.get('empConfirmed')?.value">
            <td>
              <div class="additional-fields center-section">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label class="form-label fw-bold">Contact Person Name and Surname <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="contactPersonName"
                      placeholder="Enter contact person's full name"
                      maxlength="100"
                    >
                    <div *ngIf="confirmedForm.get('contactPersonName')?.invalid && confirmedForm.get('contactPersonName')?.touched" class="text-danger small">
                      <span *ngIf="confirmedForm.get('contactPersonName')?.errors?.['required']">Contact person name is required</span>
                      <span *ngIf="confirmedForm.get('contactPersonName')?.errors?.['minlength']">Name must be at least 3 characters</span>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label class="form-label fw-bold">Contact Number <span class="text-danger">*</span></label>
                    <input
                      type="tel"
                      class="form-control"
                      formControlName="contactNumber"
                      placeholder="Enter contact number"
                      maxlength="10" lmsNumbersOnly>
                    <div *ngIf="confirmedForm.get('contactNumber')?.invalid && confirmedForm.get('contactNumber')?.touched" class="text-danger small">
                      <span *ngIf="confirmedForm.get('contactNumber')?.errors?.['required']">Contact number is required</span>
                      <span *ngIf="confirmedForm.get('contactNumber')?.errors?.['pattern']">Please enter a valid 10-digit number</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>

  <div modal-actions class="flex-container center-screen py-0 my-0">
    <button class="btn btn-primary" type="button" (click)="close()">Cancel</button>
    <button class="btn btn-primary" mdbRipple type="button" (click)="save()" >Submit</button>
  </div>
</app-lms-modal-frame>
